import React, { useRef, useState } from "react";
import FloatingPanel from "../overlays/FloatingPanel";
import "./title-actions.scss";

export default function ConfirmTitleAction({ anchorRef, label, message, allowed, onConfirm, onClose }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const saving = useRef(false);
  const close = () => { if (!saving.current) onClose(); };
  const confirm = async () => {
    if (saving.current || !allowed) return;
    saving.current = true; setBusy(true); setError("");
    try { await onConfirm(); onClose(); }
    catch (err) { setError(err.message || "The action could not be completed. Please try again."); }
    finally { saving.current = false; setBusy(false); }
  };
  return <FloatingPanel modal anchorRef={anchorRef} label={`${label}?`} width={380} onClose={close}
    initialFocus='button[data-cancel]' className="ant-title-editor">
    <h3>{label}?</h3>
    <p>{message}</p>
    {!allowed && <p role="alert">You no longer have permission to perform this action.</p>}
    {error && <p role="alert" className="ant-title-editor__error">{error}</p>}
    <div className="ant-title-editor__actions">
      <button type="button" data-cancel onClick={close} disabled={busy}>Cancel</button>
      <button type="button" className="is-danger" onClick={confirm} disabled={busy || !allowed}>{busy ? "Working…" : label}</button>
    </div>
  </FloatingPanel>;
}
